import {
  guestAskOf,
  type Assessment,
  type PersonInvolvement,
} from "@thalamos/haven-common";

import { createRoute } from "../../routing/createRoute.js";

/**
 * Where an assessment's views link to the person's Full history, or
 * undefined for a guest's assessment: the history holds only approved
 * assessments, and a guest's is never approved. Undefined too until the
 * involvements are read, since only they tell a guest's assessment apart.
 */
export const fullHistoryHrefOf = ({
  assessment,
  involvements,
  family,
}: {
  assessment: Assessment;
  /** The person's involvements; undefined until read. */
  involvements: readonly PersonInvolvement[] | undefined;
  family: string | undefined;
}): string | undefined =>
  involvements !== undefined &&
  guestAskOf(assessment, involvements) === undefined
    ? createRoute.fullHistory(assessment.personId, {
        family,
        back: assessment.id,
      })
    : undefined;
